import { Coordinate } from "ol/coordinate";
import WaypointProperties from "./WaypointProperties";

export default class WaypointSerialization {
    id: string;
    props: WaypointProperties;
    latLngCoords: Coordinate;
    constructor(id: string, props: WaypointProperties, latLngCoords: Coordinate) {
        this.id = id
        this.props = props
        this.latLngCoords = latLngCoords
    }
}